export default __webpack_public_path__ + "static/button-label-do-dark-feca66daca735a117d647d176491798629b88c867f2013366521fe955437518c.png";